import React from "react";

import Spinner from "./Spinner";
import styled from "styled-components";

const TableLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <TableLoaderDiv>
      <Spinner size="xl" color="blue-500" />
      <span className="text-xl">Fetching Data</span>
    </TableLoaderDiv>
  );
};

export default TableLoader;

const TableLoaderDiv = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  border-bottom: 1px solid #e0e0e0;
  height: calc(100vh - 350px);
  min-height: 300px;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  background-color: #fff;
`;
